<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm" class="flex flex-col">
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" type="text" placeholder="Title">
      <mat-error *ngIf="inputForm.controls['title'].hasError('required')">
        Title is required!
      </mat-error>
    </mat-form-field>
  </div>

  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field floatPlaceholder="always" floatLabel="always" appearance="outline" class="flex-1-1-100">
      <mat-label>Settings</mat-label>
      <input matInput placeholder="Input" style="display: none">
      <mat-checkbox formControlName="isArchive">
        <div>
          Archive existing filing record(s) for this Case
        </div>
        <div>
          Existing related records will be archived, but not deleted
        </div>
      </mat-checkbox>
    </mat-form-field>
  </div>
</form>
<div>
  <div>
    This Case will be used for re-submission
  </div>
  <div>
    The following required information will be retained:
  </div>
  <ul class="p-l-17 m-t-5">
    <li> Arrangement ID
    </li>
    <li>Disclosure ID</li>
  </ul>
</div>
